import { isHTMLAnchorElement } from '../utils/dom';
import { PublicService } from './publicService';
export class ConnectService extends PublicService {
    proxyService;
    constructor(isEmbed, proxyService) {
        super(isEmbed);
        this.proxyService = proxyService;
    }
    redirectTo(url) {
        this.proxyService.fireRedirectTo(url);
    }
    hookLinkElement(container) {
        container.addEventListener('click', event => {
            const target = event.target;
            if (isHTMLAnchorElement(target)) {
                event.preventDefault();
                event.stopPropagation();
                const url = target.href;
                this.redirectTo(url);
                // console.log(url)
            }
        });
    }
    onSubmit() {
        this.proxyService.onSubmit();
    }
    messageBox(options) {
        return this.proxyService.askMessageBox(options);
    }
}
